export const minus = (
    <svg width="22" height="5" viewBox="0 0 22 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.4286 0.142822H1.57143C0.703705 0.142822 0 0.846528 0 1.71425V3.28568C0 4.1534 0.703705 4.85711 1.57143 4.85711H20.4286C21.2963 4.85711 22 4.1534 22 3.28568V1.71425C22 0.846528 21.2963 0.142822 20.4286 0.142822Z" fill="#333333"/>
    </svg>
);